import { ActivatedRoute } from '@angular/router';
import { Component, Inject, Injectable, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { isPlatformBrowser } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'app-payments-approve',
  templateUrl: './payments-approve.component.html',
  styleUrls: ['./payments-approve.component.scss'],
  standalone: true,
  imports: [MatIconModule, TranslateModule, MatFormFieldModule, MatButtonModule]
})


export class PaymentsApproveComponent implements OnInit {
  @Injectable({ providedIn: 'root' })
  public pay: string | null = null;
  public title: string | null = null;
  public subtitle: string | null = null;
  public micro_copy: string | null = null;
  public loading = true;
  constructor(
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: string,

  ) {

  }

  ngOnInit(): void {
    const params = this.activatedRoute.snapshot.queryParams;
    this.pay = this.decodeIfExists(params['pay']) ?? '';
    this.title = this.decodeIfExists(params['title']) ?? '';
    this.subtitle = this.decodeIfExists(params['subtitle']) ?? '';
    this.micro_copy = this.decodeIfExists(params['micro_copy']) ?? '';

    if (this.title === null || this.title === '') this.notifyMobile('true');
    this.loading = false;
  }

  public notifyMobile(response: string): void {
    if (isPlatformBrowser(this.platformId)) {
      (window as any).webkit?.messageHandlers?.iOS?.postMessage(response);
      (window as any)['Android']?.onReceiveResult(response);
    }
  }

  private decodeIfExists(value: string | null | undefined): string | null {
    if (typeof value === 'string' && value.trim()) {
      try {
        return decodeURIComponent(value);
      } catch (e) {
        return value;
      }
    }
    return null;
  }

}

